import { Routes, Route } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import Dashboard from "../pages/Dashboard";
import AdminProtectedRoute from "../../auth/AdminProtectedRoute";
import PlaceholderPage from "../pages/PlaceholderPage";
import SubscriptionPlansManagement from "../pages/SubscriptionPlansManagement";
import AdminTimetablePage from "../pages/AdminTimetablePage";
import SessionBookingPage from "../pages/SessionBookingPage";
import AdminUserPage from "../pages/AdminUserPage";
import AdminUserDetails from "../components/users/AdminUserDetails";
import AdminSpeakerPage from "../pages/AdminSpeakerPage";
import AgendaPage from "../components/session_agenda/AgendaPage";
import AgendaItemPage from "../components/session_agenda/AgendaItemPage";
import AdminSupport from "../pages/AdminSupport";
import AdminReviewsPage from "../components/customer_reviews/AdminReviewsPage";
import AdminDatabaseBackup from "../db_backup/AdminDatabaseBackup";
import EnhancedSessionCustomersPage from "../components/time_table/EnhancedSessionCustomersPage";
import EmailCampaignPage from "../email/EmailCampaignPage";
import PaymentDashboard from "../components/payments/PaymentDashboard";
import AdminAnnouncementPage from "../announcement/AdminAnnouncementPage";
import AdminManualTasksPage from "../manual_tasks/AdminManualTasksPage";
import AdminEventPage from "../events/AdminEventPage";
import AdminEventUsersPage from "../events/AdminEventUsersPage";
import GooglePlanListPage from "../components/plans/GooglePlanListPage";
import GooglePlanFormPage from "../components/plans/GooglePlanFormPage";
import AdminAppUpdatePage from "../appUpdate/AdminAppUpdatePage";
import AdminAccountDeletionPage from "../accountHandling/AdminAccountDeletionPage";
import AdminFaqPage from "../components/faq/AdminFaqPage";
import AdminTongueTwisterPage from "../blog/AdminTongueTwisterPage";
import AdminQuickBoostPage from "../blog/quick-boost/AdminQuickBoostPage";

// ✅ NEW IMPORTS
import ContentHubPage from "../pages/ContentHubPage";
import AdminVocabularyPage from "../blog/vocabulary/AdminVocabularyPage";
import AdminVocabularyGroupPage from "../blog/vocabulary/AdminVocabularyGroupPage";
import AdminGrammarTopicPage from "../blog/grammar/AdminGrammarTopicPage";
import AdminGrammarSubTopicPage from "../blog/grammar/AdminGrammarSubTopicPage";
import AdminDailySentencePage from "../blog/daily-sentences/AdminDailySentencePage";
import AdminOfficialSentencePage from "../blog/official-sentences/AdminOfficialSentencePage";
import AdminSimilarWordsPage from "../blog/similar-words/AdminSimilarWordsPage";
import AdminIpaSymbolPage from "../blog/ipa/AdminIpaSymbolPage";
import AdminIpaLessonPage from "../blog/ipa/AdminIpaLessonPage";
import AdminPhrasePage from "../blog/phrases/AdminPhrasePage";
import AdminHomonymPage from "../blog/homonym/AdminHomonymPage";
import AdminReadingPage from "../blog/reading/AdminReadingPage";
import AdminSocialMediaPage from "../social_media/AdminSocialMediaPage";
import AdminWebImagePage from "../web_images/AdminWebImagePage";
import AdminFreeBundlePage from "../freeBundle/AdminFreeBundlePage";
import AdminAssignSessionsPage from "../userSessions/AdminAssignSessionsPage";
import AdminSessionLinksPage from "../session_links/AdminSessionLinksPage";
import AdminZoomMeetingsPage from "../zoom_meetings/AdminZoomMeetingsPage";
import AdminCoursesPage from "../courses/AdminCoursesPage";
import AdminCourseFormPage from "../courses/AdminCourseFormPage";
import AdminCurriculumPage from "../courses/AdminCurriculumPage";
import AdminBatchListPage from "../courses/AdminBatchListPage";
import AdminBatchFormPage from "../courses/AdminBatchFormPage";
import AdminBatchDetailPage from "../courses/AdminBatchDetailPage";
import AdminAssessmentPage from "../courses/AdminAssessmentPage";
import AdminBatchAssessmentsPage from "../courses/AdminBatchAssessmentsPage";
import AdminCourseDemoPage from "../courses/AdminCourseDemoPage";
import AdminCoursePaymentsPage from "../courses/AdminCoursePaymentsPage";
import AdminEnrollmentsPage from "../courses/AdminEnrollmentsPage";
import AdminCourseOfferPage from "../courses/AdminCourseOfferPage";
import AdminFreeDemoPage from "../free_demo/AdminFreeDemoPage";
import AdminLeadListPage from "../leads/AdminLeadListPage";
import AdminLeadFormPage from "../leads/AdminLeadFormPage";
import AdminLeadDetailPage from "../leads/AdminLeadDetailPage";
import ExpenseDashboard from "../components/expenses/ExpenseDashboard";
import PnLDashboard from "../components/analytics/PnLDashboard";
import CoordinatorDashboard from "../components/commission/CoordinatorDashboard";
import CommissionDashboard from "../components/commission/CommissionDashboard";
import CoordinatorReportPage from "../components/commission/CoordinatorReportPage";
import AdminGlobalCalendarSettingsPage from "../calendar/AdminGlobalCalendarSettingsPage";
import AdminGlobalCalendarPage from "../calendar/AdminGlobalCalendarPage";
import AdminBatchCalendarPage from "../calendar/AdminBatchCalendarPage";

const AdminRoutes = () => {
  return (
    <Routes>
      {/* ===============================
          PROTECTED ADMIN ROUTES
          =============================== */}
      <Route
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        {/* Dashboard */}
        <Route index element={<Dashboard />} />

        {/* Users */}
        <Route
          path="users"
          element={<AdminUserPage title="Users Management" />}
        />
        <Route path="users/:id" element={<AdminUserDetails />} />

        {/* Speakers */}
        <Route
          path="admin_speakers"
          element={<AdminSpeakerPage title="Admin Speakers" />}
        />

        {/* Session Agenda */}
        <Route path="session_agendas/:sessionId" element={<AgendaPage />} />
        <Route path="agenda-items/:agendaId" element={<AgendaItemPage />} />

        {/* Subscription */}
        <Route
          path="subscription_plans"
          element={<SubscriptionPlansManagement title="Subscription Plans" />}
        />

        {/* Time Table */}
        <Route
          path="admin_time_table"
          element={<AdminTimetablePage title="Time Table" />}
        />

        {/* Booking */}
        <Route
          path="admin_session_booking"
          element={<SessionBookingPage title="Session Booking" />}
        />

        {/* Analytics */}
        <Route path="analytics/pnl" element={<PnLDashboard />} />

        {/* Payments */}
        <Route
          path="admin-payment-dashboard"
          element={<PaymentDashboard title="Payment Dashboard" />}
        />

        {/* Announcement */}
        <Route
          path="admin-announcement"
          element={<AdminAnnouncementPage title="Announcement" />}
        />

        {/* Email */}
        <Route
          path="email-campaign-page"
          element={<EmailCampaignPage title="Email Campaign" />}
        />

        {/* Events */}
        <Route
          path="admin-events"
          element={<AdminEventPage title="Events" />}
        />
        <Route
          path="admin-events/:eventId/users"
          element={<AdminEventUsersPage />}
        />

        {/* Plans */}
        <Route
          path="google-plans/:planId"
          element={<GooglePlanListPage />}
        />
        <Route
          path="google-plans/:planId/create"
          element={<GooglePlanFormPage />}
        />
        <Route
          path="google-plans/:planId/edit/:googlePlanId"
          element={<GooglePlanFormPage />}
        />

        {/* Support */}
        <Route
          path="admin-support"
          element={<AdminSupport title="Admin Support" />}
        />

        {/* Reviews */}
        <Route
          path="admin-user-review"
          element={<AdminReviewsPage title="User Reviews" />}
        />

        {/* DB Backup */}
        <Route
          path="admin-db-backup"
          element={<AdminDatabaseBackup title="Database backup" />}
        />

        {/* Session Customers */}
        <Route
          path="sessions/:sessionId/customers"
          element={<EnhancedSessionCustomersPage />}
        />

        {/* Manual Task */}
        <Route
          path="admin-manual-task"
          element={<AdminManualTasksPage title="Manual task" />}
        />

        {/* App Update */}
        <Route
          path="admin-app-update"
          element={<AdminAppUpdatePage title="App updates" />}
        />

        {/* ===============================
            ✅ CONTENT MODULE (FIXED)
            =============================== */}

        <Route path="content" element={<ContentHubPage />} />

        <Route
          path="content/vocabulary"
          element={<AdminVocabularyPage />}
        />

        <Route
          path="content/vocabulary-groups"
          element={<AdminVocabularyGroupPage />}
        />

        <Route
          path="content/grammar"
          element={<AdminGrammarTopicPage />}
        />
        <Route
          path="content/grammar/:topicId"
          element={<AdminGrammarSubTopicPage />}
        />

        <Route
          path="content/tongue"
          element={<AdminTongueTwisterPage title="Tongue Twisters" />}
        />

        <Route
          path="content/quick-boost"
          element={<AdminQuickBoostPage title="Quick Boost" />}
        />

        <Route
          path="content/daily-sentences"
          element={<AdminDailySentencePage />}
        />

        <Route
          path="content/official-sentences"
          element={<AdminOfficialSentencePage />}
        />

        <Route
          path="content/similar-words"
          element={<AdminSimilarWordsPage />}
        />

        <Route
          path="content/ipa-symbols"
          element={<AdminIpaSymbolPage />}
        />

        <Route
          path="content/ipa-lessons"
          element={<AdminIpaLessonPage />}
        />

        <Route
          path="content/phrases"
          element={<AdminPhrasePage />}
        />

        <Route
          path="content/homonyms"
          element={<AdminHomonymPage />}
        />

        <Route
          path="content/reading"
          element={<AdminReadingPage />}
        />

        {/* Web Images */}
        <Route
          path="admin-web-images"
          element={<AdminWebImagePage />}
        />

        {/* Free Bundle */}
        <Route
          path="admin-free-bundle"
          element={<AdminFreeBundlePage />}
        />

        {/* Assign Sessions */}
        <Route
          path="assign-sessions"
          element={<AdminAssignSessionsPage />}
        />

        {/* Session Public Links */}
        <Route
          path="admin-session-links"
          element={<AdminSessionLinksPage />}
        />

        {/* Zoom Meetings */}
        <Route
          path="zoom-meetings"
          element={<AdminZoomMeetingsPage />}
        />

        {/* ===============================
            COURSES MODULE
            =============================== */}
        <Route path="courses" element={<AdminCoursesPage />} />
        <Route path="courses/payments" element={<AdminCoursePaymentsPage />} />
        <Route path="courses/enrollments" element={<AdminEnrollmentsPage />} />
        <Route path="courses/new" element={<AdminCourseFormPage />} />
        <Route path="courses/:id/edit" element={<AdminCourseFormPage />} />
        <Route path="courses/:id/curriculum" element={<AdminCurriculumPage />} />
        <Route path="courses/:id/batches" element={<AdminBatchListPage />} />
        <Route path="courses/:id/batches/new" element={<AdminBatchFormPage />} />
        <Route path="courses/:id/batches/:batchId/edit" element={<AdminBatchFormPage />} />
        <Route path="courses/:id/batches/:batchId" element={<AdminBatchDetailPage />} />
        <Route path="courses/:id/batches/:batchId/assessments" element={<AdminBatchAssessmentsPage />} />
        <Route path="courses/:id/demo" element={<AdminCourseDemoPage />} />
        <Route path="courses/:id/offer" element={<AdminCourseOfferPage />} />
        <Route path="free-demo" element={<AdminFreeDemoPage />} />
        <Route path="leads" element={<AdminLeadListPage />} />
        <Route path="leads/new" element={<AdminLeadFormPage />} />
        <Route path="leads/:id" element={<AdminLeadDetailPage />} />
        <Route path="expenses" element={<ExpenseDashboard />} />
        <Route path="coordinators" element={<CoordinatorDashboard />} />
        <Route path="coordinators/:id/report" element={<CoordinatorReportPage />} />
        <Route path="commissions" element={<CommissionDashboard />} />
        <Route path="enrollments/:enrollmentId/assessments" element={<AdminAssessmentPage />} />

        {/* Calendar */}
        <Route path="calendar/settings" element={<AdminGlobalCalendarSettingsPage />} />
        <Route path="calendar/global" element={<AdminGlobalCalendarPage />} />
        <Route path="calendar/batch/:batchId" element={<AdminBatchCalendarPage />} />

        {/* Social Media */}
        <Route path="admin-social-media" element={<AdminSocialMediaPage />} />

        {/* Account Handling */}
        <Route path="admin-account-handling" element={<AdminAccountDeletionPage />} />

        {/* FAQ */}
        <Route path="admin-faq" element={<AdminFaqPage />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
